import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import React from "react";

import {
  GhostBtn,
  ModalCard,
  ModalHeader,
  Overlay,
  PrimaryBtn,
} from "../../pagesV2/Members.styles";

type Props = {
  /** null = closed. */
  email: string | null;
  busy: boolean;
  onConfirm: () => void | Promise<void>;
  onClose: () => void;
};

/** Confirms revoking a pending seat invite (frees the reserved seat). */
export const RevokeInviteModal: React.FC<Props> = ({ email, busy, onConfirm, onClose }) => {
  if (!email) {
    return null;
  }
  return (
    <Overlay onClick={onClose}>
      <ModalCard onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <div className="title">Remove from plan?</div>
          <button className="close" onClick={onClose}>
            <CloseOutlined />
          </button>
        </ModalHeader>
        <div style={{ marginTop: 16, fontSize: 14 }}>
          <b>{email}</b> will be removed from the plan and their reserved seat freed.
        </div>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 24 }}>
          <GhostBtn onClick={onClose}>Cancel</GhostBtn>
          <PrimaryBtn disabled={busy} onClick={onConfirm}>
            {busy && <LoadingOutlined spin />}
            Yes, remove
          </PrimaryBtn>
        </div>
      </ModalCard>
    </Overlay>
  );
};
